import React from "react";
import { useLiff } from "react-liff";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

import CookieSettingPopup from "../../components/popup/CookieSettingPopup";
import house from "../../assets/images/house.svg";

import edit from "../../assets/images/icon/edit.svg";
import TopLogo from '../../components/layout/TopLogo';
import TopBanner from '../../components/layout/TopBanner';
import background from '../../assets/images/bg-info.png';
import { SearchMemberProfile } from "../../services/Member";
import { useDispatch } from 'react-redux';
import { setMember } from "../../features/MemberSlice";
import TopBtn from "../../components/layout/TopBtnMember";

export default function MemberInfoMain() {
  const [address, setAddress] = React.useState(false);
  const [member, setMemberInfo] = React.useState({});

  const [openCookiePopup, setOpenCookiePopup] = React.useState(false);


  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [page, setPage] = React.useState("info");

  const { liff } = useLiff();
  const lineId = liff.getDecodedIDToken().sub;

  function fnSetData(name, value) {
    const tmpObj = {};
    tmpObj[name] = value;
    dispatch(setMember(tmpObj));
  }


  React.useEffect(() => {
    getSearchMemberProfile()
  }, []);

  async function getSearchMemberProfile() {
    return await SearchMemberProfile({ lineId })
      .then(async (response) => {
        console.log(response.data.resultCode)
        if (+response.data.resultCode !== 20000) {
          navigate("/register");
        } else {
          if (response.data.body.memberCode) {
            setMemberInfo(response.data.body)
            if (response.data.body.addressDetails || response.data.body.amphoeName) {
              setAddress(true)
            }
            fnSetData('memberId', response.data.body.memberId)
          } else {
            navigate("/register");
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const goToEdit = () => {
    const data = {
      email: member.email,
      firstName: member.firstName,
      lastName: member.lastName,
      mobileNumber: member.mobileNumber,
      gender: member.gender,
      birthdate: member.birthdate,
      age: member.age,
    }
    navigate('/member-info-edit-profile', {
      state: {
        payload: data
      }
    });
  }

  const goToEditAddress = () => {
    const data = {
      memberId: member.memberId,
      addressDetails: member.addressDetails,
      district: member.districtName,
      amphoe: member.amphoeName,
      province: member.provinceName,
      zipCode: member.zipCode,
      isDeliveryAddress: member.isDeliveryAddress,
      deAddressDetails: member.deAddressDetails,
      deDistrict: member.deDistrictName,
      deAmphoe: member.deAmphoeName,
      deProvince: member.deProvinceName,
      deZipCode: member.deZipCode,
    }
    console.log('data bb', data);
    navigate('/member-info-edit-address', {
      state: {
        payload: data
      }
    });
  }




  function UserInfo(title, data) {
    return (
      <div className="flex justify-between items-start">
        <p className="text-gray text-[20px] whitespace-pre-line leading-[24px]">
          {title}:
        </p>
        {data ? (
          <div className="max-w-[200px] text-right text-darkGray text-[20px] whitespace-pre-line leading-[24px]">
            {data}
          </div>
        ) : (
          <p className="text-darkGray text-[20px]">-</p>
        )}
      </div>
    );
  }

  function formatDateOnly(value) {
    if (!value) return "-";

    // Keep only date part to avoid timezone shifting (off-by-one day).
    const dateText = typeof value === "string" ? value.slice(0, 10) : dayjs(value).format("YYYY-MM-DD");
    const [year, month, day] = dateText.split("-");
    if (!year || !month || !day) return "-";

    return `${day}/${month}/${year}`;
  }


  return (
    <div id="shop-page">

      <TopLogo />
      <TopBanner type="memberInfo" />
      <CookieSettingPopup
        open={openCookiePopup}
        onClose={() => {
          setOpenCookiePopup(false);
        }}
      />
      {/*<img src={ShopBanner} alt="shopbanner" className="w-full" />*/}
      <div id="shop" style={{
        backgroundImage: `url(${background})`,
        minHeight: "calc(100vh - 60px)",
        padding: "20px",
      }}
        className="gradientBg px-[20px] mt-[-40px]">

        <TopBtn type="info"></TopBtn>
        {/* <img src={bgInfo} alt="logo" style={{ width: "100%" }} /> */}
        <div className="bg-white rounded-[10px] mt-[10px]">
          <div className="flex items-center">
            <p
              onClick={() => setPage("info")}
              className={
                `w-full text-[20px] text-gray text-center py-[9px] border-b-[1px] border-lightGray ` +
                (page === "info" && "!text-blue !border-b-[4px] !border-blue")
              }
            >
              ข้อมูลผู้ใช้
            </p>
            <p
              onClick={() => setPage("address")}
              className={
                `w-full text-[20px] text-gray text-center py-[9px] border-b-[1px] border-lightGray ` +
                (page === "address" &&
                  "!text-blue !border-b-[4px] !border-blue")
              }
            >
              ที่อยู่
            </p>
          </div>

          {page === "info" ? (
            <div className="p-[16px]">
              <div className="flex gap-[10px] justify-start">
                <div className="primary-color title-size">ข้อมูลผู้ใช้</div>
                <div style={{ marginTop: "6px" }}>
                  <p className="sub-title-size"> User Information</p>
                  <div className="blue-line" ></div>
                </div>
              </div>
              <div className="flex flex-col gap-[8px] mt-[10px]">
                {UserInfo(
                  "รหัสสมาชิก",
                  `${member.memberCode}`
                )}
                {UserInfo(
                  "ชื่อ - นามสกุล",
                  `${member.firstName} ${member.lastName}`
                  // "วินัย พิมพ์นิยมตระกูล"
                )}
                {UserInfo(
                  "เพศ",
                  `${member.gender === 1 ? 'ชาย' : (member.gender === 2 ? 'หญิง' : 'กรุณากรอกข้อมูล')}`
                )}
                {UserInfo(
                  "อายุ",
                  `${member.age}`
                )}
                {UserInfo(
                  "วัน/เดือน/ปี เกิด",
                  formatDateOnly(member.birthdate)
                )}
                {UserInfo(
                  "อีเมล",
                  `${member.email || 'กรุณากรอกข้อมูล'}`
                )}

                {UserInfo(
                  "เบอร์โทรศัพท์",
                  `${member.mobileNumber || 'กรุณากรอกข้อมูล'}`
                )}
                {/* {UserInfo(
                    "รหัสผู้แนะนำ",
                    `${member.recommenderCode || '-'}`
                  )} */}
              </div>

              <button
                onClick={goToEdit}
                className="mt-[20px] w-fit flex gap-[5px] items-center justify-center py-[1px] px-[20px] rounded-[5px] border-[1px] border-blue"
              >
                <img className="w-[10px]" src={edit} alt="" />
                <p className="text-blue text-[20px]">แก้ไขข้อมูล</p>
              </button>
            </div>
          ) : (
            <div className="p-[16px]">
              <div className="flex gap-[10px] justify-start">
                <div className="primary-color title-size">ที่อยู่</div>
                <div style={{ marginTop: "6px" }}>
                  <p className="sub-title-size"> Address</p>
                  <div className="blue-line" ></div>
                </div>
              </div>

              {address ? (
                <div>
                  <div className="flex flex-col gap-[12px] mt-[10px]">
                    {UserInfo("ที่อยู่", `${member.addressDetails || '-'}`)}
                    {UserInfo("แขวง/ตำบล", `${member.districtName || '-'}`)}
                    {UserInfo("เขต/อำเภอ", `${member.amphoeName || '-'}`)}
                    {UserInfo("จังหวัด", `${member.provinceName || '-'}`)}
                    {UserInfo("รหัสไปรษณีย์", `${member.zipCode || '-'}`)}
                  </div>

                  <button
                    onClick={goToEditAddress}
                    className="mt-[20px] w-fit flex gap-[5px] items-center justify-center py-[1px] px-[20px] rounded-[5px] border-[1px] border-blue"
                  >
                    <img className="w-[10px]" src={edit} alt="" />
                    <p className="text-blue text-[20px]">แก้ไขที่อยู่</p>
                  </button>
                </div>
              ) : (
                <div>
                  <img
                    className="mx-auto mt-[20px]"
                    src={house}
                    alt="logo"
                    style={{ width: "40%", opacity: "0.6", mixBlendMode: "luminosity" }}
                  />
                  <p className="text-[20px] text-center mt-3">
                    คุณยังไม่ได้ระบุที่อยู่ โปรดระบุที่อยู่ของคุณ
                  </p>

                  <button
                    onClick={goToEditAddress}
                    className="mx-auto mt-[50px] w-fit flex gap-[5px] items-center justify-center py-[1px] px-[20px] rounded-[5px] border-[1px] border-blue"
                  >
                    <img className="w-[10px]" src={edit} alt="" />
                    <p className="text-blue text-[20px]">เพิ่มที่อยู่</p>
                  </button>
                </div>
              )}
            </div>
          )}
        </div>

        {/* <div className="my-[16px]">
          <TransparentButton onClick={() => setOpenCookiePopup(true)}>ตั้งค่านโยบายความเป็นส่วนตัวและคุกกี้</TransparentButton>
        </div> */}
        <br></br>
        <br></br>

      </div>
    </div>
  )
}